import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import upload from '@/assets/images/upload.png'
import './index.scss'
import {Button, message, Modal, Progress, Upload} from "antd";
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {otherfiles} from "../../../../servers/menuAPI";
import {refreshMenu} from "../../../../redux/common/action";
import CTable from '@/components/CTable'
import { tableData } from './data'
import {getuploadfileparams, removepic, selectPicDetail} from "../../../../servers/menu";
import Axios from "axios";
import store from "../../../../redux";
const axios = Axios.create();
@CBaseComponent
class SystemScore extends Component{

  constructor(props) {
    super(props);
    this.onSelect = this.onSelect.bind(this);
    this.downloads = this.downloads.bind(this)
    this.handlePreview = this.handlePreview.bind(this)
    this.beforeUpload = this.beforeUpload.bind(this)
    this.modalCancel = this.modalCancel.bind(this)
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    notes:'',
    uploads: {
      accept: '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.gif',
      disabled: false,
      name: 'file',
      showUploadList: false,
      defaultFileList: [],//{uid: '', name: '', url: ''}
      fileList: [],
      limit: 20,//限制上传数量 默认无限制
      size: 1024*1024*30,//默认限制大小为2M
    },
    previewVisible:false,
    previewImage:'',
    detailstatus:false,
    progress:0,
    museumid:'',
    clerklevel:'',
    loading:false
  }

  // modal取消
  modalCancel(){
    this.setState({
      previewVisible: false
    })
  }

  removeFile(file){
    Modal.confirm({
      content: '确认移除该附件',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
        this.confirmModal(file)
      }
    });
  }

  confirmModal(file){
    const params = {
      fileid:file.fileid
    }
    removepic(params).then(res=>{
      if (res.statecode === 0) {
        message.success('移除成功')
        this.onSelect()
      } else {
        message.error(res.statemessage)
      }
    })
  };
  async beforeUpload(file){
    let name = file.name;
    let currentFileType = name.split('.').pop();
    let fileType = this.state.uploads.accept.split(',');
    const result = JSON.parse(localStorage.getItem('userList'))
    if(fileType.includes(`.${currentFileType}`)){
      let params = {}
      params = {
        annexcode: 4001,
        dataid:result.museumid,
        fname:name,
        type:'1F18'
      }
      await getuploadfileparams(params).then(res=>{
        if(res.statecode === 0) {
          let formdata = new FormData()
          formdata.append('name', file.name)
          formdata.append('key', res.records[0].key)
          formdata.append('policy', res.records[0].policy)
          formdata.append('OSSAccessKeyId', res.records[0].OSSAccessKeyId)
          formdata.append('success_action_status', res.records[0].success_action_status)
          formdata.append('callback', res.records[0].callback)
          formdata.append('signature', res.records[0].signature)
          formdata.append('x:refid', res.records[0]['x:refid'])
          formdata.append('file', file)
          axios.post(
              res.records[0].host,
              formdata,
              {
                headers:
                    { 'Content-Type': 'multipart/form-data' },
                onUploadProgress:(progressEvent)=>{
                  let processStatu = (((progressEvent.loaded / progressEvent.total) * 100) | 0) ;
                  this.setState({
                    progress:processStatu
                  })
                }
              }
          )
              .then(res => {
                if (res.status === 200 && res.data.statecode === 0) {
                  message.success('上传成功')
                  this.onSelect()
                  this.setState({
                    progress:0
                  })
                } else {
                  message.error('上传失败')
                }
              })
              .catch(error => {
                message.error('上传失败')
              })
        } else {
          message.info(res.statemessage);
        }
      })
      return false;
    }else{
      message.info('请上传指定的文件类型');
    }
  }

  onSelect(){
    const result = JSON.parse(localStorage.getItem('userList'))
    const params = {
      annual:result.annual,
      museumid:this.state.museumid,
      loading:true
    }
    otherfiles(params).then(res=>{
      if(res.statecode === 0) {
        this.setState({
          dataSource:res.records[0].files,
          loading:false
        })
      } else {
        message.error('查询失败');
      }
    })
  }

  async handlePreview(file){
    if (file.filepreviewurl !== '' && file.filepreviewurl !== null) {
      const type =file.filename.split('.')[file.filename.split('.').length - 1]
      if (type === 'png' || type === 'jpg' || type === 'jpeg' || type === 'gif' || type === 'bmp' ) {
        this.setState({
          previewImage: file.filepreviewurl,
          previewVisible: true,
        });
      } else {
        window.open(file.filepreviewurl, '_blank')
      }
    }
  }

  downloads(file){
    var timer = ''
    if (file.fileurl !== '' && file.fileurl !== null) {
      clearTimeout(timer)
      window.location.href = file.fileurl
    } else {
      timer = setTimeout(()=>{
        this.handlePreview(file)
      },1)
    }
  }

  // 点击modal打开
  async handlePreview(file){
    const params = {
      fileid: file.fileid
    }
    selectPicDetail(params).then(res=>{
      if (res.statecode === 0 && res.records[0].filepreviewurl !== '' && res.records[0].filepreviewurl !== null) {
        window.open(res.records[0].filepreviewurl, '_blank')
      }
    })
  }

  downloads(file){
    const params = {
      fileid: file.fileid
    }
    let timer = null
    selectPicDetail(params).then(res=>{
      if (res.statecode === 0 && res.records[0].fileurl !== '' && res.records[0].fileurl !== null) {
        clearTimeout(timer)
        window.location.href = res.records[0].fileurl
      } else {
        timer = setTimeout(()=>{
          this.handlePreview(file)
        },1)
      }
    })
  }

  componentDidMount(){
    const result = JSON.parse(localStorage.getItem('userList'))
    this.setState({
      clerklevel:result.clerklevel
    })
    if (result.clerklevel == 8 || result.clerklevel == 9){
      this.setState({
        museumid:result.museumid,
      },()=>{
        this.onSelect()
      })
    } else {
      this.setState({
        museumid:store.getState().libraryid
      },()=>{
        this.onSelect()
      })
    }
    store.subscribe(() => {
      const state = store.getState()
      if (state.libraryname){
        const museumid = store.getState().libraryid
        this.setState({
          museumid:museumid,
        },()=>{
          this.onSelect();
        })
      }
    })
  }

  render(){
    return (
        <div className='detail-container'>
          {(this.state.clerklevel == 8 || this.state.clerklevel == 9) &&
              <div style={{width:'110px'}}>
                <Upload
                    {...this.state.uploads}
                    action='#'
                    beforeUpload={(file, fileList) => this.beforeUpload(file)}
                    onRemove={(file) => this.removeFile(file)}
                >
                  <div><Button type='primary'><img src={upload} alt="" style={{width:'20px'}}/>上传文件</Button></div>
                </Upload>
                {this.state.progress>0?<Progress percent={this.state.progress}/>:''}
              </div>
          }
          <div className="import" style={{marginTop:'20px'}}>
          <CTable ref='historyRecordDeleteUserList' checked={false}  loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource}>
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index+1}
                    </div>
                )} />
            <div
                slot='yl'
                render={(text, record, index) => (
                    <div className='operate'>
                      <span style={{color:'#1890ff',cursor:'pointer'}} onClick={()=>{this.handlePreview(record)}}>预览</span>
                    </div>
                )} />
            <div
                slot='download'
                render={(text, record, index) => (
                    <div className='operate'>
                      <span style={{color:'#1890ff',cursor:'pointer'}} onClick={()=>{this.downloads(record)}}>下载</span>
                    </div>
                )} />
            <div
                slot='delete'
                render={(text, record, index) => (
                    <div className='operate'>
                      <span style={{color:'#1890ff',cursor:'pointer'}} onClick={()=>{this.removeFile(record)}}>删除</span>
                    </div>
                )} />
          </CTable>
            <Modal visible={this.state.previewVisible} footer={null} onCancel={this.modalCancel}>
              <div style={{width:'100%',height:'400px',display:'flex',justifyContent:'center',alignItems:'center'}}>
                <img alt="example" style={{ maxWidth: '400px' }} src={this.state.previewImage} />
              </div>
            </Modal>
          </div>
        </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    collapsed: state.collapsed,  // 侧边栏是否展开
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps,mapDispatchToProps))(SystemScore);
